import SingleEvent from "./SingleEvent";

export default SingleEvent;
